var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.000000, -561.000000)",
    fill: "#A0A5B5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.000000, 561.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9223387,33.6672581 C9.24096774,33.6672581 2.17741935,26.6058871 2.17741935,17.9245161 C2.17741935,9.24096774 9.24096774,2.17741935 17.9223387,2.17741935 C26.6037097,2.17741935 33.6650806,9.24096774 33.6650806,17.9245161 C33.6650806,26.6058871 26.6037097,33.6672581 17.9223387,33.6672581 M17.9223387,0 C8.03903226,0 0,8.03903226 0,17.9245161 C0,27.8056452 8.03903226,35.8446774 17.9223387,35.8446774 C27.8034677,35.8446774 35.8425,27.8056452 35.8425,17.9245161 C35.8425,8.03903226 27.8034677,0 17.9223387,0 M26.055,12.7008871 L19.0110484,17.8809677 L19.0110484,7.12451613 C19.0110484,6.52137097 18.5233065,6.03580645 17.9223387,6.03580645 C17.321371,6.03580645 16.833629,6.52137097 16.833629,7.12451613 L16.833629,20.0322581 C16.833629,20.4437903 17.0644355,20.8204839 17.4302419,21.0055645 C17.5870161,21.0839516 17.7546774,21.1209677 17.9223387,21.1209677 C18.1487903,21.1209677 18.3752419,21.0491129 18.5668548,20.9119355 L27.3462097,14.4580645 C27.8295968,14.1009677 27.9341129,13.4194355 27.5791935,12.9360484 C27.2220968,12.4483065 26.5405645,12.3437903 26.055,12.7008871"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsap);
export default __webpack_public_path__ + "static/media/asap.0a73ebee855f7532b00c0b05849f2b0f.svg";
export { ForwardRef as ReactComponent };